import { type FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';

import { captureException } from '@sentry/react';

import MessageModal from 'components/admin/MessageModal';

import { removeAdminUser } from 'services/user';

import { P_ADMIN_ADMIN_USERS, useGlobalStateObject } from 'utils';

type PropsT = {
  onCancel: () => void;
  userId: string;
};

export const RemoveAdminModal: FunctionComponent<PropsT> = ({
  onCancel,
  userId,
}) => {
  const [busy, setBusy] = useState(false);

  const gs = useGlobalStateObject();
  const navigate = useNavigate();

  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      icon="WARN"
      onCancel={onCancel}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);
            await removeAdminUser(userId);

            let au = gs.get('adminUsers.data');
            if (au) {
              const idx = au.findIndex((item) => item.id === userId);
              if (idx >= 0) {
                au = [...au];
                au.splice(idx, 1);
                gs.set('adminUsers.data', au);
              }
            }

            void navigate(P_ADMIN_ADMIN_USERS);
          } catch (error) {
            captureException(error);
            // TODO: Proper error message!
            // eslint-disable-next-line no-alert
            alert('Failed to remove the admin');
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      <h1>Are you sure you want to remove this admin user?</h1>
      <p>
        This action cannot be undone. If you remove an admin, you&apos;ll need
        to send a new invitation to reactivate them.
      </p>
    </MessageModal>
  );
};

export default RemoveAdminModal;
